import * as React from "react";
import {Row, Button, Col, Card, Alert} from "react-bootstrap";
import { Project } from "../../interfaces/Project";
import {Link} from "react-router-dom";
import {Bar} from "react-chartjs-2";

interface IProps {
    project: Project;
}

export default ({project} : IProps) => (
    <Card className="project">
        <Card.Body className="p-0">
            <Alert variant="danger" className="mb-0 weather-warning">
               <div className="d-flex align-items-center">
                    <div className="mr-4 left">
                        <i className="fas fa-exclamation-triangle" />
                    </div>
                    <div className="middle">
                        <p className="font-weight-bold p-0 m-0">Weather warning!</p>
                        <p className="p-0 m-0">Some other message</p>                   
                    </div>
                    <div className="right text-right">
                        <Link to={`/projects/${project.id}`}>
                            Open details
                        </Link>
                    </div>
               </div>
            </Alert>
            <Row noGutters={true}>
                <Col md={10} xs={12}>
                    <div className="p-4">
                        <Row noGutters={true}>
                            <Col md={9} xs={12}>
                                <h3>{project.name}</h3>
                                <div>
                                    <p>{project.description}</p>
                                </div>
                                <div>
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>Works on site</Col>
                                                <Col>{project.users.length}</Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col>Equipment status</Col>
                                                <Col>Ok</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div>
                                    <Bar 
                                        data={{
                                            datasets: [{
                                                data: [0, -40, 20, 40]
                                            }],
                                            labels: ['January', 'February', 'March', 'April']
                                        }}
                                        height={200}
                                        options={{ 
                                            legend: {
                                                display: false
                                            },
                                            responsive: false
                                        }}                           
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col md={2} xs={12} className="right-side">
                    <div className="p-4">
                        <Row noGutters={true}>
                            <Col>
                                <span>Assigned contactors</span>
                            </Col>
                            <Col>{project.users.length}</Col>
                        </Row>
                        <Row noGutters={true}>
                            <Col>
                                <span>Sites</span>
                            </Col>
                            <Col>{project.sites.length}</Col>
                        </Row>
                        <Row className="bottom-button">
                            <Col className="text-center">
                                <Link to={`/projects/${project.id}`}>
                                    <Button>Open project</Button>
                                </Link>
                            </Col>
                        </Row>                        
                    </div>
                </Col>
            </Row>
        </Card.Body>
    </Card>
)